import { events } from '@theme/constants';
import { getAttributeValue } from '@theme/dom';
import { publish } from '@theme/event-bus';
import { fetchConfig, json } from '@theme/fetch';
import { getCartSectionNames, isUntilBreakpoint, throttle } from '@theme/helpers';
import { HTMLCustomElement } from '@theme/html-custom-element';

export class QuickAdd extends HTMLCustomElement {
  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    this.on('click', this, (event) => {
      if (this.refs.link && this.refs.link.contains(event.target)) {
        return;
      }

      if (event.target.dataset.ref === this.refs.variant.dataset.ref) {
        this.handleVariantSelect(event);
        return;
      }

      /**
       * Ensures that any parent links aren't followed.
       */
      event.preventDefault();
    });

    this.on(
      'scroll',
      window,
      throttle(() => {
        if (isUntilBreakpoint('large') && this.refs.toggleElement) {
          this.refs.toggleElement.close();
        }
      }),
    );
  }

  /**
   * Handles the variant click event.
   * @param {MouseEvent} event - The event payload.
   */
  handleVariantSelect(event) {
    event.preventDefault();

    const detail = {
      id: Number(event.target.dataset.id),
      quantity: 1,
    };

    if (this.hasAttribute('selling-plan')) {
      detail.selling_plan = this.getAttribute('selling-plan');
    }

    if (getAttributeValue(this, 'method') === 'emit') {
      this.dispatchEvent(new CustomEvent('variant-select', { detail }));
      return;
    }

    event.target.disabled = true;

    try {
      json(
        fetch(
          theme.routes.cart_add_url,
          fetchConfig('json', {
            body: JSON.stringify({
              items: [detail],
              sections: getCartSectionNames(),
            }),
          }),
        ),
      ).then((response) => {
        publish(events.cartUpdated);
        publish(events.cartAdded);
        publish(events.sectionUpdate, { sections: response.sections });

        event.target.disabled = false;

        if (this.refs.toggleElement) {
          this.refs.toggleElement.close();
        }
      });
    } catch {
      event.target.disabled = false;
    }
  }
}

if (!customElements.get('quick-add')) customElements.define('quick-add', QuickAdd);
